'use client';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from '@/app/lib/store'; // Adjust your path

import DataDispatcher from '../components/dispatchers/data-dispatcher';

import { InitialData } from '@/app/lib/schemas/types/app-types';

interface Props {
  initialData: InitialData;
}

export default function ClientProviders({ initialData }: Props) {
  return (
    <Provider store={store}>
      <PersistGate
        loading={null}
        persistor={persistor}
      >
        <DataDispatcher initialData={initialData} />
      </PersistGate>
    </Provider>
  );
}
